import { Link } from "react-router-dom";
import { ShieldAlert, LogIn } from "lucide-react";
import { useTheme } from "../contexts/ThemeContext";
import Header from "../header/Header";
import { theme } from "../theme";

export const WelcomePage = () => {
  const { theme: currentTheme } = useTheme();
  const isDark = currentTheme === "dark";

  return (
    <div className={theme.layout.page}>
      {/* Atmospheric background layers */}
      <div className="fixed inset-0 pointer-events-none overflow-hidden" aria-hidden="true">
        <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[900px] h-[500px] rounded-full dark:opacity-100 opacity-0 blur-[100px] bg-sy-teal/[0.035]" />
        <div
          className="absolute inset-0 dark:opacity-[0.035] opacity-[0.025]"
          style={{
            backgroundImage: "radial-gradient(circle at 1px 1px, currentColor 1px, transparent 0)",
            backgroundSize: "32px 32px",
          }}
        />
      </div>

      <Header />

      {/* Main content — centered */}
      <div className="flex-1 flex flex-col items-center justify-center px-6 py-12 relative">

      {/* Logo with soft glow */}
      <div className="relative mb-6 animate-fadeInUp">
        <div className="absolute inset-0 dark:bg-sy-teal/10 blur-3xl rounded-full scale-[2] opacity-0 dark:opacity-100" aria-hidden="true" />
        <img
          src={isDark ? "/sy-logo-light.png" : "/sy-logo-dark.png"}
          alt="Safeguarding You"
          className="h-20 relative"
        />
      </div>

      {/* Headline */}
      <div className="text-center mb-6 animate-fadeInUp animation-delay-100">
        <h1 className="text-2xl font-bold dark:text-white text-gray-900 mb-2 tracking-tight">
          Welcome to Charlie
        </h1>
        <p className="dark:text-white/50 text-gray-500 text-sm max-w-[230px] mx-auto leading-relaxed">
          Your AI concussion co-pilot for community sport
        </p>
      </div>


      {/* Primary action */}
      <div className="w-full max-w-xs space-y-3 animate-fadeInUp animation-delay-200">
        <Link
          to="/assessment/public"
          className="flex items-center justify-center w-full min-h-[64px] rounded-2xl bg-sy-red text-white text-base font-semibold px-6 py-4 hover:brightness-110 transition-all duration-150 active:scale-[0.97] select-none shadow-lg shadow-sy-red/[0.22]"
        >
          <ShieldAlert className="w-5 h-5 mr-2.5 flex-shrink-0" />
          Sideline Assessment
        </Link>
      </div>

      {/* Sign-in link */}
      <div className="mt-7 animate-fadeInUp animation-delay-300">
        <Link
          to="/login"
          className="inline-flex items-center gap-2 dark:text-white/35 text-gray-400 dark:hover:text-white/65 hover:text-gray-600 transition-colors duration-200 text-sm font-medium"
        >
          <LogIn className="w-4 h-4" />
          Sign in for full access
        </Link>
      </div>

      {/* Medical disclaimer */}
      <p className="mt-8 text-xs dark:text-white/22 text-gray-400 text-center max-w-[280px] mx-auto animate-fadeInUp animation-delay-300 leading-relaxed">
        Charlie is not a medical device. All suspected concussions should be assessed by a qualified medical professional. If in doubt, call{" "}
        <a
          href="tel:000"
          className="underline underline-offset-2 dark:text-white/38 text-gray-500 dark:hover:text-white/55 hover:text-gray-700 transition-colors duration-200"
        >
          Triple Zero (000)
        </a>.
      </p>
      </div>
    </div>
  );
};
